export default {
  // 标签页
  saveToNewCase: "保存画布至新案件",
  saveToExistingCase: "画布保存至已有案件",
  
  // 表单标签
  caseName: "案件名称",
  caseType: "案件类型",
  caseTypeName: "案件类型名称",
  policeType: "警种",
  caseDescription: "案件说明",
  canvasName: "画布名称",
  case: "案件",
  
  // 占位符
  pleaseEnterCaseName: "请输入案件名称(必填)",
  pleaseSelectCaseType: "请选择案件类型(必填)",
  pleaseSelectCaseTypeName: "请选择案件类型名称",
  pleaseEnterPoliceType: "请输入警种",
  pleaseEnterCaseDescription: "请输入案件说明",
  pleaseEnterCanvasName: "请输入画布名称",
  pleaseSelectCase: "请选择案件",
  
  // 按钮
  reset: "重置",
  saveCanvas: "保存画布",
  
  // 验证消息
  caseNameRequired: "案件名称为必填项",
  caseNameLength: "长度在 1 到 20个字符",
  caseTypeRequired: "请选择案件类型",
  caseRequired: "请选择案件",
  descriptionLength: "长度在 1 到 200个字符",
  canvasNameRequired: "画布名称为必填项",
  canvasNameLength: "长度在 1 到 20个字符",
  
  // 成功消息
  saveSuccess: "保存画布成功",
};
